import { Directive } from '@angular/core';

@Directive({
  selector: '[appMoldCreateDialogFormButtons]',
  standalone: true,
})
export class MoldCreateFormButtonsDirective {
  constructor() {}
}
